<template>
  <div ref="hint" class="base-hint" :class="{ 'is-open': isOpen }" @mouseenter="computeAlign" @click="toggle">
    <Icon class="base-hint__icon" name="/base/question.svg" :style="iconSize" />
    <div ref="tooltip" class="base-hint__tooltip" :class="[alignClass, { 'is-below': isBelow }]">{{ text }}</div>
  </div>
</template>

<script>
import './hint.scss'

import Icon from '@/components/Base/Icon/Icon.vue'

// max-width тултипа 240px / 2
const TOOLTIP_HALF_WIDTH = 120
const VIEWPORT_PADDING = 8

export default {
  name: 'Hint',
  components: { Icon },
  props: {
    text: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 20
    }
  },
  data() {
    return {
      // На тач-устройствах :hover не срабатывает — открываем по тапу
      isOpen: false,
      alignClass: '',
      isBelow: false
    }
  },
  computed: {
    iconSize() {
      return { width: `${this.size}px`, height: `${this.size}px` }
    }
  },
  mounted() {
    this.computeAlign()
    document.addEventListener('click', this.onDocumentClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocumentClick)
  },
  methods: {
    // Тултип центрируется по иконке и у краёв экрана уезжал бы за вьюпорт —
    // прижимаем его к той стороне, где есть место.
    computeAlign() {
      const el = this.$refs.hint

      if (!el) return

      const rect = el.getBoundingClientRect()
      const iconCenterX = rect.left + rect.width / 2

      if (iconCenterX + TOOLTIP_HALF_WIDTH > window.innerWidth - VIEWPORT_PADDING) {
        this.alignClass = 'align-left'
      } else if (iconCenterX - TOOLTIP_HALF_WIDTH < VIEWPORT_PADDING) {
        this.alignClass = 'align-right'
      } else {
        this.alignClass = ''
      }

      this.computeSide(rect)
    },
    // Тултип раскрывается вверх и у верхнего края обрезается ближайшим
    // скроллящимся родителем (карточки форм — с overflow). Если места нет —
    // разворачиваем вниз. Считаем от иконки, а не от самого тултипа, иначе
    // положение перещёлкивалось бы туда-обратно.
    computeSide(iconRect) {
      const tooltip = this.$refs.tooltip

      if (!tooltip) return

      const limitTop = this.getClipperTop()

      this.isBelow = iconRect.top - tooltip.offsetHeight - VIEWPORT_PADDING < limitTop
    },
    getClipperTop() {
      let el = this.$refs.hint?.parentElement

      while (el && el !== document.body) {
        const { overflow, overflowY } = getComputedStyle(el)

        if (/auto|scroll|hidden/.test(overflow) || /auto|scroll|hidden/.test(overflowY)) {
          return el.getBoundingClientRect().top
        }

        el = el.parentElement
      }

      return VIEWPORT_PADDING
    },
    toggle() {
      this.computeAlign()
      this.isOpen = !this.isOpen
    },
    onDocumentClick(event) {
      if (this.isOpen && !this.$refs.hint?.contains(event.target)) this.isOpen = false
    }
  }
}
</script>
